import { render, staticRenderFns } from "./WavePickAbandon.vue?vue&type=template&id=3a1901da&scoped=true&"
import script from "./WavePickAbandon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WavePickAbandon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1901da",
  null
  
)

export default component.exports